import { render, staticRenderFns } from "./IvrForm.vue?vue&type=template&id=2625b017&scoped=true&"
import script from "./IvrForm.vue?vue&type=script&lang=js&"
export * from "./IvrForm.vue?vue&type=script&lang=js&"
import style0 from "./IvrForm.vue?vue&type=style&index=0&id=2625b017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2625b017",
  null
  
)

export default component.exports